import { ApolloError } from "@apollo/client";

export const parseMFATokenError = (error: ApolloError): string => {
    if (error.message.includes("ChallengeId not found")) {
        return "auth.MFA.error.loginChallengeNotFound";
    }

    if (error.message.includes("Too many tries")) {
        return "auth.MFA.error.tooManyTokenTries";
    }

    if (
        error.message.includes("Invalid code")
        || error.message.includes("Not allowed")
    ) {
        return "auth.MFA.error.invalidCode";
    }

    if (error.message.includes("Rate limited")) {
        return "auth.MFA.error.rateLimit";
    }

    if (error.message.includes("Not allowed")) {
        return "error.notAllowed";
    }

    return "auth.MFA.error";
};
